import React from 'react';
import type { PublicFiche } from '../types';
import { FicheCardBase } from './FicheCardBase';
import { RGPDSection }   from './sections/RGPDSection';
import { CJUELinksSection } from './sections/CJUELinksSection';

interface FicheCardRGPDProps {
  fiche:      PublicFiche;
  showScore?: boolean;
  compact?:   boolean;
}

/**
 * Carte décision RGPD.
 * Affiche les badges RGPD + liens CJUE validés entre le problème et le footer.
 */
export const FicheCardRGPD = ({ fiche, showScore = false, compact = false }: FicheCardRGPDProps) => {
  const validatedLinks = (fiche.rgpd_cjue_links ?? []).filter(l => l.validated === true);

  return (
    <FicheCardBase
      fiche={fiche}
      showScore={showScore}
      compact={compact}
      borderVariant="rgpd"
    >
      <RGPDSection fiche={fiche} />
      {validatedLinks.length > 0 && (
        <CJUELinksSection links={validatedLinks} />
      )}
    </FicheCardBase>
  );
};